<template>
  <div> 
    <CalendarHeader
      :month="month"
      :year="year"
      :monthNames="monthNames"
      @prev-month="$emit('prev-month')"
      @next-month="$emit('next-month')"
    />

    <div class="calendar-grid">
      <div
        v-for="(day, i) in weekDays"
        :key="'label-' + i"
        class="calendar-weekday"
        :class="{ weekend: i === 5 || i === 6 }"
      >
        {{ day }}
      </div>

      <div
        v-for="(day, index) in daysInMonth"
        :key="index"
        class="calendar-day"
        :class="{
          weekend: isWeekend(index),
          empty: day === null,
          today: isToday(day),
          hasAppointment: highlightDays.includes(day)
        }"
        @click="day && $emit('day-selected', day)"
      >
        <span v-if="day">{{ day }}</span>
      </div>
    </div>

    <YaklasanRandevular />
  </div>
</template>

<script>
import CalendarHeader from './CalendarHeader.vue';
import YaklasanRandevular from './YaklasanRandevular.vue';

export default {
  name: 'CalendarMonth',
  components: { CalendarHeader, YaklasanRandevular },
  props: {
    year: { type: Number, required: true },
    month: { type: Number, required: true },
    monthNames: { type: Array, required: true },
    highlightDays: { type: Array, default: () => [] }
  },
  data() {
    const today = new Date();
    return {
      todayDate: today.getDate(),
      todayMonth: today.getMonth(),
      todayYear: today.getFullYear()
    };
  },
  computed: {
    weekDays() {
      return ['mon','tue','wed','thu','fri','sat','sun'].map(k => this.$t(`randevu.weekdays.${k}`));
    },
    daysInMonth() {
      const total = new Date(this.year, this.month + 1, 0).getDate();
      const first = new Date(this.year, this.month, 1).getDay();
      const offset = first === 0 ? 6 : first - 1;
      return [
        ...Array(offset).fill(null),
        ...Array.from({ length: total }, (_, i) => i + 1)
      ];
    }
  },
  methods: {
    isWeekend(index) {
      return [5, 6].includes(index % 7);
    },
    isToday(day) {
      return (
        day &&
        day === this.todayDate &&
        this.month === this.todayMonth &&
        this.year === this.todayYear
      );
    }
  }
};
</script>

  
  <style scoped>
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
  }
  
  .calendar-day {
    border: 1px solid #2b2b2b;
    background-color: #050505;
    padding: 10px;
    border-radius: 4px;

    background-color: #060606;
    padding: 20px 10px;
    border: 1px solid #ffffff00;


    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.5s ease, color 0.2s ease;
  }
  
  .calendar-day:hover:not(.empty) {
    background-color: #022121;
  }
  
  .empty {
    cursor: default;
    background: transparent;
    border: none;
  }
  
  .weekend {
    background-color: #1a1a1a;
  }
  
  .today {
    border: 1px solid #0B7C05;
  }
  
  .calendar-weekday {
    font-weight: 400;
    text-align: center;
    padding: 8px;
    border-bottom: 1px solid #444;
    color: white; 
    background-color: #050505; 
  }
  .hasAppointment {
    background-color: #011111 ;
  }

  </style>
  